import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminOnboarding() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);
  const [roleFilter, setRoleFilter] = useState("all");

  useEffect(() => {
    api.get("/admin/onboarding").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const filtered = items.filter((i) => roleFilter === "all" || i.role === roleFilter);

  return (
    <div className="p-8 lg:p-12" data-testid="admin-onboarding-page">
      <div className="font-mono text-[10px] tracking-[0.4em] text-neutral-500 mb-2">ONBOARDING</div>
      <h1 className="font-bodoni text-5xl md:text-7xl mb-8">Transmissions.</h1>

      <div className="flex gap-2 mb-8">
        {["all", "fighter", "creator", "client"].map((r) => (
          <button
            key={r}
            onClick={() => setRoleFilter(r)}
            data-testid={`ob-filter-${r}`}
            className={`px-4 py-2 font-mono text-[10px] tracking-widest border ${
              roleFilter === r ? "border-white bg-white text-black" : "border-neutral-900 text-neutral-400"
            }`}
          >
            {r.toUpperCase()}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="border border-neutral-900 p-16 text-center font-mono text-xs text-neutral-600 tracking-widest">
          NO TRANSMISSIONS YET
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-px bg-neutral-900">
          <div className="lg:col-span-1 bg-black divide-y divide-neutral-900 max-h-[75vh] overflow-y-auto">
            {filtered.map((o) => (
              <button
                key={o.id}
                onClick={() => setActive(o)}
                data-testid={`onboarding-${o.id}`}
                className={`w-full text-left p-4 hover:bg-neutral-950 ${active?.id === o.id ? "bg-neutral-950 border-l-2 border-white" : ""}`}
              >
                <div className="flex items-baseline justify-between">
                  <div className="font-bodoni text-lg">{o.name}</div>
                  <div className="font-mono text-[9px] text-neutral-500 uppercase">{o.role}</div>
                </div>
                <div className="font-mono text-[10px] text-neutral-500 truncate">{o.email}</div>
                <div className="font-mono text-[10px] text-neutral-700 mt-1">{o.project_type || "—"}</div>
              </button>
            ))}
          </div>
          <div className="lg:col-span-2 bg-black p-8">
            {active ? (
              <div data-testid="onboarding-detail">
                <div className="font-mono text-[10px] text-neutral-500 tracking-widest mb-2">{active.role?.toUpperCase()}</div>
                <div className="font-bodoni text-4xl mb-1">{active.name}</div>
                <a href={`mailto:${active.email}`} className="font-mono text-sm text-neutral-400 link-underline">{active.email}</a>

                <div className="grid grid-cols-2 gap-4 mt-8 border border-neutral-900 divide-y divide-neutral-900 font-mono text-xs">
                  {[
                    ["PHONE", active.phone],
                    ["LOCATION", active.location],
                    ["SOCIALS", active.socials],
                    ["PROJECT", active.project_type],
                    ["TIMELINE", active.timeline],
                    ["BUDGET", active.budget],
                    ["REFERRAL", active.referral],
                  ].map(([k, v]) => (
                    <div key={k} className="col-span-2 grid grid-cols-3 p-4 gap-4 border-b border-neutral-900">
                      <div className="text-neutral-600 tracking-widest">{k}</div>
                      <div className="col-span-2 text-white break-words">{v || "—"}</div>
                    </div>
                  ))}
                </div>

                <div className="font-mono text-[10px] text-neutral-500 tracking-widest mt-8 mb-2">VISION</div>
                <div className="font-mono text-sm text-neutral-300 whitespace-pre-wrap border-l-2 border-neutral-900 pl-4">{active.vision || "—"}</div>

                <div className="font-mono text-[10px] text-neutral-700 mt-8 tracking-widest">
                  RECEIVED {new Date(active.created_at).toLocaleString()}
                </div>
              </div>
            ) : (
              <div className="font-mono text-xs text-neutral-600 tracking-widest cursor-blink">SELECT A TRANSMISSION</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
